import Footer from "../components/Footer.tsx";
import LoginForm from "../components/login/LoginForm.tsx";
import InputBox from "../components/core/InputBox";
import { ROUTE_LOGIN, ROUTE_SETTING } from "../const/routes.ts";
import SEO from "../components/core/SEO.tsx";

const Login = () => {
  scrollTo(0, 0);
  return (
    <div className="safe-bottom-with-dock bg-base-100 text-base-content min-h-screen ">
      <SEO
        title="Anmelden"
        description="Melde dich auf Surfanzeigen an."
        url={ROUTE_LOGIN}
      />
      <div className="relative flex flex-col items-center bg-[url(/background.png)] bg-[50%_20%] lg:bg-[60%_50%] bg-cover">
        <div className="absolute inset-0 bg-gradient-to-b from-info/60 via-accent/20 to-base-300" />
        <main className="flex justify-center items-center grow max-w-2xl w-full h-screen p-page">
          <InputBox>
            <LoginForm redirectTo={ROUTE_SETTING} />
          </InputBox>
        </main>
      </div>
      <Footer />
    </div>
  );
};

export default Login;
